var _MoreVert;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { node, object, string } from 'prop-types';
import clsx from 'clsx';
import { MoreVert } from 'mosaic-react-icons';
import { useTheme } from '@mui/material/styles';
import SovosIconMenu from '../sovos-icon-menu';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';

/**
 * **Note**: must be a child of `SovosToolbarActions`
 */
const SovosToolbarMoreMenu = _ref => {
  let {
    children,
    className,
    color,
    IconButtonProps = {},
    MenuProps = {},
    moreLabel,
    size,
    ...rest
  } = _ref;
  const theme = useTheme();
  const {
    t
  } = useMosaicTranslation();
  return /*#__PURE__*/React.createElement(SovosIconMenu, _extends({
    className: clsx('sovosToolbarMoreMenu', className),
    MenuProps: MenuProps,
    IconButtonProps: {
      ...IconButtonProps,
      color: color || theme.palette.text.primary
    },
    iconElement: // eslint-disable-next-line react/jsx-wrap-multilines
    _MoreVert || (_MoreVert = /*#__PURE__*/React.createElement(MoreVert, null)),
    size: size,
    toolTipText: moreLabel || t('more')
  }, rest), children);
};
SovosToolbarMoreMenu.propTypes = {
  /**
   * The content of the menu. Must be an array of `SovosMenuItem`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Can be 'primary', 'default', or a valid css color. Default is the text color.
   */
  color: string,
  /**
   * Props passed to the Icon button component
   */
  IconButtonProps: object,
  /**
   * Props passed to the Menu component
   */
  MenuProps: object,
  /**
   * Text of the icon button `aria-label` & tooltip
   */
  moreLabel: string,
  /**
   * Size of the icon button. One of: `small`, `medium`
   */
  size: string
};
export default SovosToolbarMoreMenu;